import { useState } from 'react'
import { Users, Search, Plus, MoreHorizontal } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import { Avatar, AvatarFallback } from '@/components/ui/avatar'
import { Loading } from '@/components/ui/loading'
import { useUsers } from '@/hooks'
import { cn } from '@/utils'

export function UsersPage() {
  const [search, setSearch] = useState('')
  const { data: usersData, isLoading } = useUsers({ search })

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-slate-900 dark:text-white flex items-center gap-2">
            <Users className="w-6 h-6 text-green-500" />
            用户管理
          </h1>
          <p className="text-slate-500 dark:text-slate-400 mt-1">
            管理系统用户、部门和权限
          </p>
        </div>
        <Button className="gap-2">
          <Plus className="w-4 h-4" />
          添加用户
        </Button>
      </div>

      <Card>
        <CardHeader className="pb-4">
          <div className="flex items-center justify-between">
            <CardTitle>用户列表</CardTitle>
            <div className="relative w-64">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
              <Input
                placeholder="搜索用户..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="pl-9"
              />
            </div>
          </div>
        </CardHeader>
        <CardContent>
          {isLoading ? (
            <Loading className="py-12" />
          ) : (
            <div className="divide-y divide-slate-200 dark:divide-slate-800">
              {usersData?.items?.map((user) => (
                <div
                  key={user.id}
                  className="flex items-center justify-between py-4 hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors"
                >
                  <div className="flex items-center gap-4">
                    <Avatar className="w-10 h-10">
                      <AvatarFallback className="bg-indigo-100 text-indigo-600">
                        {user.full_name?.[0] || user.username[0]}
                      </AvatarFallback>
                    </Avatar>
                    <div>
                      <p className="font-medium text-slate-900 dark:text-white">
                        {user.full_name}
                      </p>
                      <p className="text-sm text-slate-500">
                        {user.email}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center gap-4">
                    <div className="text-sm text-slate-500">
                      {user.department || '未分配'}
                    </div>
                    <Badge
                      variant={user.is_active ? 'default' : 'secondary'}
                      className={cn(
                        user.is_active && 'bg-green-100 text-green-800 hover:bg-green-100'
                      )}
                    >
                      {user.is_active ? '在职' : '离职'}
                    </Badge>
                    <Button variant="ghost" size="icon">
                      <MoreHorizontal className="w-4 h-4" />
                    </Button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  )
}
